import { BaseAPIModel } from '@weezevent/weezjs-core';
import { ArgumentError } from '../utils/errors';

/**
 * Widget.
 *
 * @param {Object} params - Object parameter
 * @constructor
 */
export default class Widget extends BaseAPIModel {
    fields() {
        return {
            id: { readOnly: true, primaryKey: true },
            widget_key: {},
            name: {},
            widget_events: {},
            all_events: {},
            creation_date: {},
            default_language: {},
            widget_event_key: {},
            languages: {}
        };
    }

    get widget_key() {
        return this.object.widget_key;
    }
    get all_events() {
        return this.object.all_events;
    }
    get events() {
        return this.object.events;
    }
    get languages() {
        return this.object.languages || [];
    }

    get is_multi() {
        return this.object.first_step === null;
    }

    code_url(lang, color, preview = false) {
        const widget_key = this.object.widget_key || this.object.widget_event_key;
        return window.weezConfig.api.widgetUrl + '/ticket/' + widget_key + '?locale=' + lang + (preview ? '#weez_preview' : '');
    }

    code_href(lang) {
        return this.code_url(lang);
    }

    code_width() {
        return this.object.customs?.width ?? '650';
    }

    code_height() {
        return this.object.customs?.height ?? '600';
    }

    code_resize() {
        let resize = 1;
        if (!this.object.customs.auto_dimension) {
            if (Object.prototype.hasOwnProperty.call(this.object.customs, 'height') || Object.prototype.hasOwnProperty.call(this.object.customs, 'width')) {
                if (parseInt(this.code_height()) !== 0 && parseInt(this.code_width()) !== 0) {
                    resize = 0;
                }
            }
        }
        return resize;
    }

    hide_power_by_weez() {
        if (!this.object.customs) {
            return 0;
        }
        return this.object.customs && this.object.customs.display_powered_by_weez ? 0 : 1;
    }

    // TODO: migrate to @weezevent/weezjs-core BaseAPIModel
    static findOne(args, search) {
        return this.getAll(args, {
            search: Object.values(search).join(',')
        }).then(objects => {
            if (!objects.length) {
                return null;
            }

            let result = objects.filter(object => {
                return Object.entries(search).every(([key, value]) => {
                    return object[key] === value;
                });
            });

            if (!result.length) {
                return null;
            }

            return result[0];
        });
    }

    static listUrl({ organizationId, widgetId }) {
        if (!organizationId) {
            throw new ArgumentError('[Model][Widget] organizationId is mandatory');
        }

        return `/ticket/organizations/${organizationId}/widgets`;
    }
}
